export enum Filter {
  all = 'all',
  active = 'active',
  completed = 'completed',
}
